module.exports = __webpack_public_path__ + "img/banner1.6b434111.png";